<template>
  <div id="app">
    <section class="el-container is-vertical">
      <header class="el-header" style="height: 80px; z-index: 5;">
        <div data-v-d09d3a8e="" class="content el-col el-col-24" style="padding: 10px;"><button data-v-d09d3a8e=""
            type="button" @click="mnav" class="el-button hidden-sm-and-up navbar-toggler el-button--default is-plain"><span><i
                data-v-d09d3a8e="" :class="mnavclass"></i></span></button> <a data-v-d09d3a8e="" href="/home"
            class=""><img data-v-d09d3a8e="" src="/static/logo.png" class="logo"></a>
          <button data-v-d09d3a8e="" @click="mreg" type="button"
            class="el-button hidden-sm-and-up navbar-toggler el-button--default is-plain"><span><i data-v-d09d3a8e=""
                :class="mregclass"></i></span></button>
          <div data-v-d09d3a8e="" class="collapse justify-content-between hidden-xs-only">
            <div data-v-d09d3a8e="" class="hidden-xs-only"><a data-v-d09d3a8e="" href="/lists" :class="navlists" class="navbar-nav">信息</a>
              <a data-v-d09d3a8e="" href="/merchant" :class="navmerchant" class="navbar-nav">商家</a> <a data-v-d09d3a8e="" href="/publish"
                class="navbar-nav" :class="navpublish">发布</a> <a data-v-d09d3a8e="" href="/upgrade" class="navbar-nav" :class="navupgrade">VIP</a> <a
                data-v-d09d3a8e="" href="/help" :class="help" class="navbar-nav"> 帮助</a>
            </div>
            <div data-v-d09d3a8e="" class="hidden-sm-and-down">
              <form data-v-f7e5fc18="" data-v-d09d3a8e="" class="el-form" @submit.prevent="searchSubmit">
                <div data-v-f7e5fc18="" class="el-input el-input-group el-input-group--append">
                  <input type="text" autocomplete="off" v-model="search.q" placeholder="搜索信息" class="el-input__inner">
                  <div class="el-input-group__append">
                    <button data-v-f7e5fc18="" type="submit" class="el-button el-button--default"><i class="el-icon-search"></i></button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div v-if="userpuid===1" data-v-d09d3a8e="" class="collapse justify-content-end hidden-xs-only">
            <a data-v-d09d3a8e="" href="/login" class="navbar-nav">登录</a>
            <a data-v-d09d3a8e="" href="/registered" class="navbar-nav">注册</a>
          </div>
          <div v-if="userpuid!==1" data-v-d09d3a8e="" class="collapse justify-content-end hidden-xs-only">
            <a data-v-d09d3a8e="" href="/usercenter" class="navbar-nav right-nav"><svg data-v-73b7ef61="" data-v-d09d3a8e="" aria-hidden="true" class="svg-icon"><use data-v-73b7ef61="" xlink:href="#icon-user"></use></svg>会员中心</a>
          </div>
        </div>
      </header>
      <div data-v-6efbb9a0="" class="C-MobileNav">
        <div data-v-6efbb9a0="" :style="{ display:mdisplay}" class="navbar-nav LeftNavBar transition-box content"><a
            data-v-6efbb9a0="" href="/home" class="nav-link el-icon-s-home transition-box"> 首页</a> <a data-v-6efbb9a0=""
            href="/lists" class="nav-link el-icon-date transition-box"> 信息</a> <a data-v-6efbb9a0="" href="/merchant"
            class="nav-link el-icon-s-shop transition-box"> 商家</a> <a data-v-6efbb9a0="" href="/publish"
            class="nav-link el-icon-edit transition-box"> 发布</a> <a data-v-6efbb9a0="" href="/upgrade"
            class="nav-link el-icon-star-on transition-box"> VIP升级</a> <a data-v-6efbb9a0="" href="/help"
            class="nav-link el-icon-question transition-box"> 帮助</a>
          <div data-v-6efbb9a0="" class="nav-link transition-box">
            <form data-v-f7e5fc18="" data-v-6efbb9a0="" class="el-form" @submit.prevent="searchSubmit">
              <div data-v-f7e5fc18="" class="el-input el-input-group el-input-group--append"><input type="text"
                  autocomplete="off" placeholder="搜索信息" v-model="search.q" class="el-input__inner">
                <div class="el-input-group__append"><button data-v-f7e5fc18="" type="submit"
                    class="el-button el-button--default"><i class="el-icon-search"></i></button></div>
              </div>
            </form>
          </div>
        </div>
        <div v-if="userpuid===1" data-v-6efbb9a0="" :style="{ display:mreglogindisplay }" class="navbar-nav LeftNavBar transition-box content">
          <a data-v-6efbb9a0="" href="/login" class="nav-link el-icon-s-home transition-box "> 登录</a>
          <a data-v-6efbb9a0="" href="/registered" class="nav-link el-icon-message-solid transition-box"> 注册</a>
        </div>
        <div v-if="userpuid!==1" data-v-6efbb9a0="" :style="{ display:mregmemberdisplay }" class="navbar-nav LeftNavBar transition-box content">
          <a data-v-6efbb9a0="" href="/usercenter" class="nav-link transition-box">
            <svg data-v-73b7ef61="" data-v-6efbb9a0="" aria-hidden="true" class="svg-icon">
              <use data-v-73b7ef61="" xlink:href="#icon-user">
              </use>
            </svg>会员中心</a>
          <a data-v-6efbb9a0="" href="/publish" class="nav-link transition-box">
            <svg data-v-73b7ef61="" data-v-6efbb9a0="" aria-hidden="true" class="svg-icon">
              <use data-v-73b7ef61="" xlink:href="#icon-publish">
              </use>
            </svg>信息发布</a>
          <a data-v-6efbb9a0="" href="/myinfo" class="nav-link transition-box">
            <svg data-v-73b7ef61="" data-v-6efbb9a0="" aria-hidden="true" class="svg-icon">
              <use data-v-73b7ef61="" xlink:href="#icon-info">
              </use>
            </svg>我的信息</a>
          <a data-v-6efbb9a0="" href="/myfavorite" class="nav-link transition-box">
            <svg data-v-73b7ef61="" data-v-6efbb9a0="" aria-hidden="true" class="svg-icon">
              <use data-v-73b7ef61="" xlink:href="#icon-noheart">
              </use>
            </svg>我的收藏</a>
          <a data-v-6efbb9a0="" href="/upgrade" class="nav-link transition-box">
            <svg data-v-73b7ef61="" data-v-6efbb9a0="" aria-hidden="true" class="svg-icon">
              <use data-v-73b7ef61="" xlink:href="#icon-vip">
              </use>
            </svg>升级vip</a>
          <a data-v-6efbb9a0="" href="/editprofile" class="nav-link transition-box">
            <svg data-v-73b7ef61="" data-v-6efbb9a0="" aria-hidden="true" class="svg-icon">
              <use data-v-73b7ef61="" xlink:href="#icon-user-management">
              </use>
            </svg>修改资料</a>
          <a href="/logout"><div data-v-6efbb9a0="" class="nav-link" style="cursor: pointer;">
            <svg data-v-73b7ef61="" data-v-6efbb9a0="" aria-hidden="true" class="svg-icon">
              <use data-v-73b7ef61="" xlink:href="#icon-exit">
              </use>
            </svg>退出</div></a>
        </div>
      </div>
      <main class="el-main content">
        <div class="qzbanner el-card" v-if="bans">
          <a v-for="ban in banarray" :href="ban.url" target="_blank"><img :src="ban.img"></a>
        </div>
        <router-view />
      </main>
      <el-backtop></el-backtop>
      <footer class="el-footer" style="height: 100%;">
        <div data-v-849ad2bc="" class="p-5">
          <span data-v-849ad2bc="">Copyright © 51风流-全国凤楼信息平台 All rights reserved.</span></div>
      </footer>
    </section>
  </div>
</template>

<script>
import cookie from 'js-cookie'
export default {
  name: 'App',
  data () {
    return {
      navlists:'',
      navmerchant:'',
      navpublish:'',
      navupgrade:'',
      help:'',

      search:{
        q:'',
      },

      userpuid:cookie.get('sessionid') || 1,

      banarray:[],
      bans:false,

      mdisplay:'none',
      mnavclass:'el-icon-s-unfold', //默认 点击后el-icon-caret-top

      mreglogindisplay:'none',
      mregmemberdisplay:'none',
      mregclass:'el-icon-user-solid',  //默认el-icon-user-solid
    }
  },
  methods:{
    mnav(){

      this.mreglogindisplay = 'none';
      this.mregmemberdisplay = 'none';
      this.mregclass = 'el-icon-user-solid';

      this.mnavclass = this.mnavclass === 'el-icon-s-unfold' ? 'el-icon-caret-top' : 'el-icon-s-unfold';

      this.mdisplay = this.mdisplay === 'none' ? 'flex' : 'none';

    },
    mreg(){

      this.mdisplay = 'none';
      this.mnavclass = 'el-icon-s-unfold';

      if(this.userpuid===1){

        this.mregmemberdisplay = 'none';

      }else{

        this.mreglogindisplay = 'none';
        this.mregmemberdisplay = this.mregmemberdisplay === 'none' ? 'flex' : 'none';
      }

      this.mregclass = this.mregclass === 'el-icon-user-solid' ? 'el-icon-caret-top' : 'el-icon-user-solid';

      this.mreglogindisplay = this.mreglogindisplay === 'none' ? 'flex' : 'none';

    },
    searchSubmit(){

      let key = this.search.q
      if(key){

        window.location.href = '/search?q='+this.search.q

      }else{

        this.$message({
          message: '请输入搜索关键词',
          type: 'error'
        });

      }
      
    }
  },
  mounted(){

    //cookie.remove('sessionid')

    let key = this.$route.query.q
    this.search.q = key
    
    let rt = this.$route.name
    if(rt==='lists' || rt==='show'){
      this.navlists = 'active'
    }else if(rt==='merchant' || rt==='merchantshow' || rt==='merchantjoin'){
      this.navmerchant = 'active'
    }else if(rt==='publish'){
      this.navpublish = 'active'
    }else if(rt==='upgrade'){
      this.navupgrade = 'active'
    }else if(rt==='help'){
      this.help = 'active'
    }


    this.$http.get('/api/ban').then(res=>{

      if(res.data.length>0){

        this.bans = true

        this.banarray = res.data

      }

    })

  }
}
</script>

<style>
.qzbanner {
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中（可选） */
  gap:5px;
  flex-wrap: wrap;          /* 超出换行（可选） */
  padding-top: 10px;
  padding-bottom: 5px;
}
.qzbanner img {
  max-width: 98%;
  height: auto;
  border-radius: 8px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue